import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getUserName } from '../../userLocalDetails.js';
import {
  MainContainer,
  LeftSide,
  Title,
  RightSide,
  NotificationAccount,
  Notification,
  HeaderHelpBar,
  HelpbarContainer,
  Account,
  Screen,
  NavigationContainer,
  DropDownContainer,
  TitleMain,
  ArrowRightImg,
  TitleConatiner,
  DocumentName,
  TeacherActionsContainer,
} from './HeaderStyle';
import helpbarIcon from '../../static/img/helpgray24.svg';
import LoginIcon from '../../static/icons/login-icon.svg';
import addBtnIcon from '../../static/icons/gradient_add.svg';
import notificationsIcon from '../../static/icons/Notifications.svg';
import RoundedBorderLeftIconBtn from '../../components2/Buttons/RoundedBorderLeftIconBtn';
import NotificationsBar from '../NotificationsMenu/NotificationsBar/index.jsx';
import ProfileDropdown from '../ProfileMenu/ProfileDropdown/index.jsx';
import HeaderTitle from './headerTitle.js';
import { Avatar } from '@boringer-avatars/react';
import HelpSidebar from '../../components2/HelpSidebar/index.jsx';
import { isTeacher } from './rules.js';
import HeaderOnboardingMenu from '../../components2/Onboard/HeaderOnboardingMenu.jsx';
import { useActiveClassData, useNotifications } from '../state/hooks.js';
import Loader from '../Loader/index.jsx';
import Cookies from 'js-cookie';
import { AppContext } from '../../app.context.js';
import { TourContext } from '../../TourContext.jsx';
import { isLoggedIn } from '../../service.js';
import { Buttons1 } from '../TaskCard/style.js';
import RoundedBorderSubmitBtn from '../../components2/Buttons/RoundedBorderSubmitBtn/index.jsx';
import { externalIDPUrl } from '../../utils/login.js';
import FreemiumButton from '../../components2/freemium/index.jsx';
import { useProfile } from '../state/hooks.js';
import {
  getJeddaiRole,
  getRemainingCredits,
  getTotalCredits,
  getSubscriptionTier,
  canHaveUnlimitedCredits,
  canAccessTasks,
  getUpgradeOptions,
  canUpgradeTo,
  canCreateTask,
  getCurrentPlan,
  isNonSchoolTeacherRole
} from '../../utils/userAccessHelper.js';
import TeacherPlanUpgradePopup from '../../components2/freemium/TeacherPlanUpgradePopup/index.jsx';
import StudentPlanUpgradePopup from '../../components2/freemium/StudentPlanUpgradePopup/index.jsx';

const Header = ({ breadcrumbs, staticBreadcrumbs }) => {
  const context = useContext(AppContext) || {};
  const {
    showTeacherOnboarding,
    activateSidebarOverlay,
    deactivateSidebarOverlay,
  } = context;
  // Raw useContext, NOT the useTour() hook — useTour throws outside a
  // TourProvider, and this header also mounts in test harnesses (and must
  // degrade to "no onboarding surface" there), same defensive pattern as
  // AppContext above.
  const tourContext = useContext(TourContext) || {};
  // Any full-screen onboarding surface: the teacher welcome carousel, the
  // setup-checklist takeover, or one of the five tours. While one is up,
  // the notifications drawer must never be open — this header is mounted
  // both INSIDE the checklist takeover (the inert context header, elevated
  // above the z-2000 overlay by OnBoardingCompleteStyle) and by
  // VisibilityWrapper on the mirror routes that have no header of their
  // own (/onboarding/marking + tools), so a drawer opened from state
  // floats over the takeover/tour and sidesteps both the inert wrapper
  // and the tour click-lock (those only block pointer hits, not
  // state-driven opens).
  const onboardingSurfaceActive = Boolean(
    showTeacherOnboarding ||
      tourContext.showOnboardingComplete ||
      tourContext.markingTourActive ||
      tourContext.draftTourActive ||
      tourContext.newTaskTourActive ||
      tourContext.feedbackTourActive ||
      tourContext.wizardTourActive,
  );
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isHelpBarOpen, setIsHelpBarOpen] = useState(false);
  const [dropDown, setDropDown] = React.useState(false);
  const [pageHeight, setPageHeight] = useState(0);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [isPlanUpgradeOpen, setIsPlanUpgradeOpen] = useState(false);
  const [planType, setPlanType] = useState(null);
  const [showAllPlans, setShowAllPlans] = useState(false);
  const notificationBarRef = useRef(null);
  const history = useHistory();
  const { data: classData, isLoadingdata: isLoadingclassData } = useActiveClassData();
  const name = getUserName();
  const { data: profile, setData: setProfile, isLoadingdata: isLoadingProfile } = useProfile();
  
  const jeddaiRole = getJeddaiRole(profile);
  const noTaskAccess = !canAccessTasks(profile);
  const upgradeOptions = getUpgradeOptions(profile);

  const getInitialPlanType = () => {
    if (profile) {
      if (canUpgradeTo(profile, 'TEACHER_TO_PRO')) {
        return 'TEACHER';
      } else if (canUpgradeTo(profile, 'STUDENT_TO_PLUS') || canUpgradeTo(profile, 'STUDENT_TO_PRO')) {
        return 'STUDENT';
      }
    }
    return 'STUDENT';
  };

  const currentPlanType = planType || getInitialPlanType();



  // See note in components/Header/index.jsx — assignment-expression form
  // crashes under strict mode (ES modules).
  const { data: notifications, isLoadingdata: isLoading } = useNotifications(
    null,
    true,
    300000,
  );

  // JED-985: the drawer never opens on its own — only the bell opens it.

  // If the drawer is already open when an onboarding surface activates,
  // close it immediately — no slide-out animation, the takeover already
  // covers the page and an animated drawer would linger above it for 300ms.
  useEffect(() => {
    if (onboardingSurfaceActive && isNotificationOpen) {
      setIsNotificationOpen(false);
      setSliderOpen(false);
    }
  }, [onboardingSurfaceActive, isNotificationOpen]);

  const handleNewTaskClick = () => {
    history.push('/tasks/new');
  };

  const togglePlanUpgradeModal = (open) => {
    if (open) {
      if (!isPlanUpgradeOpen && activateSidebarOverlay) {
        activateSidebarOverlay();
      }
    } else if (isPlanUpgradeOpen && deactivateSidebarOverlay) {
      deactivateSidebarOverlay();
    }
    setIsPlanUpgradeOpen(open);
    setPlanType(null);
    setShowAllPlans(false);
  };

  const handleUpgradeClick = () => {
    togglePlanUpgradeModal(true);
  };

  const toggleDropDown = () => {
    setDropDown(!dropDown);
    setIsNotificationOpen(false);
  };

  const handleNotificationClick = () => {
    if (!isNotificationOpen) {
      // The bell inside the checklist takeover is inert / pointer-blocked,
      // but keyboard + programmatic activations still land here — never
      // open the drawer over an onboarding surface. (Closing below stays
      // allowed; the force-close effect keeps this state unreachable
      // anyway.)
      if (onboardingSurfaceActive) return;
      setIsNotificationOpen(true);
      setSliderOpen(true);
    } else {
      setSliderOpen(false);
      setTimeout(() => {
        setIsNotificationOpen(false);
      }, 300);
    }
  };

  const closeNotificationBarRef = useRef(() => {
    if (isNotificationOpen) {
      setSliderOpen(false);
      setTimeout(() => {
        setIsNotificationOpen(false);
      }, 300);
    }
  });

  closeNotificationBarRef.current = () => {
    if (isNotificationOpen) {
      setSliderOpen(false);
      setTimeout(() => {
        setIsNotificationOpen(false);
      }, 300);
    }
  };

  window.closeNotificationBar = closeNotificationBarRef.current;

  const handleHelpBarClick = () => {
    setIsNotificationOpen(false);
    if (!isHelpBarOpen) {
      setIsHelpBarOpen(true);
      setSliderOpen(true);
      setIsNotificationOpen(false);
      setDropDown(false);
    } else {
      setSliderOpen(false);
      setTimeout(() => {
        setIsHelpBarOpen(false);
      }, 300);
    }
  };
  
  const handleLogin = () => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocalhost) return;
    const currentUrl = new URL(window.location.href);
    const currentPathname = currentUrl.hash
      ? currentUrl.hash.substring(1)
      : currentUrl.pathname;

    localStorage.setItem('redirectPath', `/#${currentPathname}`);

    const authUrl = externalIDPUrl();
    if (authUrl) {
      window.location.href = authUrl;
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = document.documentElement.scrollHeight;
      if (fullHeight !== pageHeight) {
        setPageHeight(fullHeight - 120);
      }
    };

    const observer = new MutationObserver((mutations) => {
      let shouldUpdateHeight = false;

      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldUpdateHeight = true;
          break;
        }
      }

      if (shouldUpdateHeight) {
        updateHeight();
      }
    });

    const config = { childList: true, subtree: true };

    observer.observe(document.body, config);

    updateHeight();

    return () => observer.disconnect();
  }, []);

  // Not gated on the notifications fetch: the drawer shows its own spinner
  // (loadingNotifications), so a slow GET /notifications never blanks the
  // header.
  if (isLoadingclassData || isLoadingProfile) {
    return <Loader />;
  }

  if (!isLoggedIn()) {
    return (
      <MainContainer>
        <LeftSide>
          <HeaderTitle breadcrumbs={breadcrumbs} staticBreadcrumbs={staticBreadcrumbs} />
        </LeftSide>
        <RightSide>
          <RoundedBorderSubmitBtn
            leftIcon={LoginIcon}
            text="Login"
            onClickFn={handleLogin}
          />
        </RightSide>
      </MainContainer>
    );
  }
  return (
    <div
      ref={notificationBarRef}
      style={{
        position: 'sticky',
        top: '0',
        zIndex: 100,
        borderBottom: '1px solid rgba(255, 255, 255, 1)',
        boxShadow: '2px 1px 4px 0px rgba(115, 115, 115, 0.25)',
      }}
    >
      <MainContainer>
        <LeftSide>
          <HeaderTitle breadcrumbs={breadcrumbs} staticBreadcrumbs={staticBreadcrumbs} />
        </LeftSide>
        <RightSide>
          {canCreateTask(profile) && (
            <TeacherActionsContainer>
              <RoundedBorderLeftIconBtn
                onclick={handleNewTaskClick}
                leftIcon={addBtnIcon}
                btnText="New Task"
              />
            </TeacherActionsContainer>
          )}
                      <FreemiumButton
                 creditsRemaining={getRemainingCredits(profile)}
                 totalCredits={getTotalCredits(profile)}
                 planType={getSubscriptionTier(profile)}
                 creditType={canHaveUnlimitedCredits(profile) ? "unlimited" : "limited"}
                 onUpgradeClick={handleUpgradeClick}
               />
          <NotificationAccount>
            {(!isTeacher(jeddaiRole) || isNonSchoolTeacherRole(profile)) && <HeaderOnboardingMenu />}
            <HeaderHelpBar src={helpbarIcon} onClick={handleHelpBarClick} />
            <Notification
              src={notificationsIcon}
              alt="Notifications"
              onClick={handleNotificationClick}
            />
            <Account onClick={toggleDropDown}>
              <Avatar
                title={false}
                size={36}
                variant="beam"
                name={name}
                square={false}
              />
            </Account>
          </NotificationAccount>
        </RightSide>
        {isHelpBarOpen && (
          <Screen
            onClick={handleHelpBarClick}
            pageHeight={pageHeight}
            bgColor={'rgba(0, 0, 0, 0.5)'}
          >
            <HelpbarContainer
              isHelpBarOpen={sliderOpen}
              ref={notificationBarRef}
            >
              <HelpSidebar onCloseFn={handleHelpBarClick} />
            </HelpbarContainer>
          </Screen>
        )}
        {isNotificationOpen && (
          <Screen
            onClick={handleNotificationClick}
            notifications={notifications}
            pageHeight={pageHeight}
            bgColor={'rgba(0, 0, 0, 0.5)'}
          >
            <NavigationContainer
              slideNotificationBar={sliderOpen}
              pageHeight={document.documentElement.scrollHeight}
              onClick={(e) => e.stopPropagation()}
              ref={notificationBarRef}
            >
              {' '}
              <NotificationsBar
                notifications={notifications}
                refreshOnOpen
                loadingNotifications={isLoading}
                onCloseFn={handleNotificationClick}
              />{' '}
            </NavigationContainer>
          </Screen>
        )}
        {dropDown && (
          <Screen onClick={toggleDropDown} pageHeight={pageHeight}>
            <DropDownContainer>
              <ProfileDropdown />
            </DropDownContainer>
          </Screen>
        )}
        
        <TeacherPlanUpgradePopup
          eventTrigger="credits_pill"
          isOpen={isPlanUpgradeOpen && currentPlanType === 'TEACHER'}
          onClose={() => togglePlanUpgradeModal(false)}
          onPlanSelect={() => togglePlanUpgradeModal(false)}
          upgradeOptions={upgradeOptions}
          showAllPlans={showAllPlans}
          currentPlan={getCurrentPlan(profile)}
          profile={profile}
        />
        <StudentPlanUpgradePopup
          eventTrigger="credits_pill"
          isOpen={isPlanUpgradeOpen && currentPlanType === 'STUDENT'}
          onClose={() => togglePlanUpgradeModal(false)}
          onPlanSelect={() => togglePlanUpgradeModal(false)}
          upgradeOptions={upgradeOptions}
          showAllPlans={showAllPlans}
          currentPlan={getCurrentPlan(profile)}
          profile={profile}
        />
      </MainContainer>
    </div>
  );
};

export default Header;
